import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../_services";
@Component({
    selector: "application-down",
    templateUrl: "./application-down.component.html",
    styleUrls: ["./application-down.component.scss"],
    standalone: false
})
export class ApplicationDownComponent implements OnInit  {
    constructor(private router: Router, private authenticationService: AuthenticationService) {
    }

    private healthCheckInterval: any;
    ngOnInit() {
        this.healthCheckInterval = setInterval(() => {
            this.authenticationService.checkDomainEnabledForSSO('yopmail.com').subscribe(
                (userData) => {
                    clearInterval(this.healthCheckInterval);
                    this.router.navigate(['/settings']);
                },
                (error) => {console.error('Application is down', error);}
              );

        }, 10000); 
      }
}